// src/helpers/WebsocketHelper.js

export default class WebsocketHelper {
  // A utility function to create a promise that resolves after a specified timeout
  static promiseTimeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // A utility function to handle reconnection attempts with a limit
  static async reconnectWithLimit(connectFn, maxAttempts = 5, delay = 1000) {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        await connectFn();
        console.log(`WebSocket connected on attempt ${attempt}`);
        return;
      } catch (error) {
        console.error(
          `WebSocket connection failed on attempt ${attempt}:`,
          error
        );
        if (attempt < maxAttempts) {
          console.log(`Retrying in ${delay}ms...`);
          await this.promiseTimeout(delay);
        } else {
          console.error("Max reconnection attempts reached.");
          throw error;
        }
      }
    }
  }
}
